import { render, staticRenderFns } from "./MainShop.vue?vue&type=template&id=28164fc1&scoped=true&"
import script from "./MainShop.vue?vue&type=script&lang=js&"
export * from "./MainShop.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "28164fc1",
  null
  
)

export default component.exports